/* eslint-disable max-len */
import React from 'react'
import SadRobbie from './robbie.svg'

const LocationErrorMessage = ({ locationName }) => {
  return (
    <div>
      <p>
        <b>Hello, and thank you for using the Occupancy Map!</b>
      </p>
      <p>
        Unfortunately, <b>{locationName}</b> is not yet enabled.
      </p>
      <p>
        {
          'FYI, Occupancy Map Tool draws data from two primary sources: "Sales Floor Plan" in '
        }
        <a href="https://stargate.wework.com">Stargate</a>
        {', and "Your Inventory" in '}
        <a href="https://spacestation.wework.com">Spacestation</a>
        {'.'}
      </p>
      <p>
        So for the tool to correctly reflect ‘reality’, it is essential that
        these two data inputs are accurate and up-to-date. Unfortunately, we
        cannot do this on our end, so the request back to yourself/local team is
        to:
      </p>
      <ol>
        <li>
          <b>
            Review the Sales Floor Plan within Stargate and ensure it is
            accurate and up-to-date.
          </b>{' '}
          If it is not, please contact your local development/BIM team to modify
        </li>
        <li>
          <b>
            Review the Inventory data within Spacestation and ensure it is
            accurate and up-to-date.
          </b>{' '}
          If it is not, please contact your local sales/pricing team to modify
        </li>
      </ol>
      <p>
        After these two datasets are confirmed as correct, please let us know by
        submitting a ticket to{' '}
        <a
          href="https://wecompany.force.com/employeesupport/s/apps-and-digital-products"
          target="blank"
        >
          https://wecompany.force.com/employeesupport/s/apps-and-digital-products
        </a>
        , choosing Occupancy Map Support and completing the form. The Product
        Support team will respond shortly.
        <br />
        <br />
        Thanks!
      </p>
    </div>
  )
}

const FloorErrorMessage = () => {
  return (
    <div>
      <p>
        Hmm, it looks like this floor is not yet mapped. Please check the
        following:
      </p>
      <ol>
        <li>
          <b>
            Review this specific level of the Sales Floor Plan in Stargate and
            ensure it is accurate and up-to-date.
          </b>{' '}
          If it is not, please contact your local Development/VDC team to modify
        </li>
        <li>
          <b>
            Review the Inventory data for this specific level in Spacestation
            and ensure it is accurate and up-to-date.
          </b>{' '}
          If it is not, please contact your local Pricing/Rev Ops team to modify
        </li>
      </ol>
      <p>
        After these two datasets are confirmed as correct, please let us know by
        submitting a ticket to{' '}
        <a
          href="https://wecompany.force.com/employeesupport/s/apps-and-digital-products"
          target="blank"
        >
          https://wecompany.force.com/employeesupport/s/apps-and-digital-products
        </a>
        , choosing Occupancy Map Support and completing the form. The Product
        Support team will respond shortly.
        <br />
        <br />
        Thanks!
      </p>
    </div>
  )
}

const genericErrorMsg = `
Hmm, it looks like an error has occurred.  Please reload the page to try again!
<br />
<br />
If you see this message again, please submit a ticket to <a href="https://wecompany.force.com/employeesupport/s/apps-and-digital-products" target="_blank">https://wecompany.force.com/employeesupport/s/apps-and-digital-products</a>, choose Occupancy Map Support and complete the form.  The Product Support team will respond shortly.
`

const GenericErrorMessage = ({ message }) => {
  return (
    <p
      style={{
        padding: '40px',
        color: '#000',
        lineHeight: 1.4,
      }}
      dangerouslySetInnerHTML={{
        __html: message,
      }}
    />
  )
}

const ErrorMessage = ({ locationName, floorName, message }) => {
  if (message) {
    return <GenericErrorMessage message={message} />
  }

  if (locationName) {
    return <LocationErrorMessage locationName={locationName} />
  }

  if (floorName) {
    return <FloorErrorMessage floorName={floorName} />
  }

  return <GenericErrorMessage message={genericErrorMsg} />
}

const ErrorPage = ({ locationName, floorName, message }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9f9f9',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'row',
          maxWidth: 1000,
          margin: 'auto',
          zIndex: 1000,
        }}
      >
        <SadRobbie style={{ width: 200, height: 'auto' }} />
        <div
          style={{
            flex: 1,
            color: '#404040',
            maxWidth: 1000,
            padding: 40,
            lineHeight: 1.4,
          }}
        >
          <ErrorMessage
            locationName={locationName}
            floorName={floorName}
            message={message}
          />
        </div>
      </div>
    </div>
  )
}

export default ErrorPage
